import { useDispatch, useSelector } from 'react-redux';
import { notificationError, notificationSuccess } from '../../../../../../Notifications/callNotifcation';
import DeletingTagWindow from './DeletingTagWindow';
import { RootState } from '../../../../../../../redux/reducers/reducer';
import { useActionCreators } from '../../../../../../../shared';
import { all, tagModalsActive } from '../selectors/tag';
import { privateTemplateModuleTagAPI } from '../../../../../../../entities/module/private-template-module-tag/api/api';
import { privateTemplateModuleTagGroupAPI } from '../../../../../../../entities/template/private-template-tag-group/template-tag-group/api/privateTemplateModuleTagGroupAPI';
import { privateTemplateModuleAPI } from '../../../../../../../entities/module/private-template-module/api/api';
import { privateTemplateModuleTagActions } from '../../../../../../../entities/module/private-template-module-tag/model/template-module-tag';

const DeletingModuleTagWrapper = () => {
	const dispatch = useDispatch();

	const isDeletingTagModalActive = useSelector((state: RootState) => tagModalsActive(state).isDeletingTagModalActive);

	const deletingTagId = useSelector((state: RootState) => all(state).deletingTagId);

	const [deleteTag] = privateTemplateModuleTagAPI.useDeleteMutation();

	const actions = useActionCreators(privateTemplateModuleTagActions);

	const handleDeletingModal = (value: boolean) => {
		dispatch(actions.setIsDeletingTagModalActive(value));
	};

	const onDeleteTag = async () => {
		if (deletingTagId) {
			try {
				await deleteTag({ id: deletingTagId })
					.unwrap();
				dispatch(privateTemplateModuleTagGroupAPI.util?.invalidateTags(['tag_group']));
				dispatch(privateTemplateModuleAPI.util?.invalidateTags(['modules']));
				handleDeletingModal(false);
				notificationSuccess('Тег удален успешно');
			} catch (e) {
				notificationError('Возникла ошибка при удалении тега...');
			}
		}
	};
	return (
		<DeletingTagWindow
			onDelete={onDeleteTag}
			handleDeletingModal={handleDeletingModal}
			isDeletingModalActive={isDeletingTagModalActive}
			text="Тег будет удален из всех модулей, где он используется. Действие нельзя будет отменить."
		/>
	);
};

export default DeletingModuleTagWrapper;
